const Contact = () => {
    return (<div className="contact">
        <h1>Hello From the Contact component</h1>
    </div>)
} 

export default Contact